import { bulkUpdateNews, delNews, getAllNews, postNews, putNews } from "../dataProviders/admin/news";
import { useUserStore } from "../stores/user";
import useDataQuery from "./useDataQuery";

export const useNews = (args?: { onCreateSuccess?: () => void }) => {

    const userStore = useUserStore();

    const { data: news, isLoading, invalidateQuery } = useDataQuery({ query: getAllNews, uniqueKey: 'news', placeholder: [], useCache: 'short' });


    const normalNews = computed(() => {
        if (!userStore.isAuthenticated) return;

        return news.value?.filter(n => n.type === 'normal')
    })

    const importantNews = computed(() => {
        if (!userStore.isAuthenticated) return;

        return news.value?.filter(n => n.type === 'important')
    })

    const { mutate: createNews, isPending: isCreating } = useMutation({
        mutationFn: postNews,
        onSuccess: () => {
            invalidateQuery();
            args?.onCreateSuccess?.();
        },

    });

    const { mutate: updateNews, isPending: isUpdating } = useMutation({
        mutationFn: putNews,
        onSuccess: invalidateQuery,
    });

    const { mutate: deleteNews, isPending: isDeleting } = useMutation({
        mutationFn: delNews,
        onSuccess: invalidateQuery,
    });

    const { mutate: bulkUpdate, isPending: isBulkUpdating } = useMutation({
        mutationFn: bulkUpdateNews,
        onSuccess: invalidateQuery,
    });

    return {
        news,
        normalNews,
        importantNews,
        isLoading,
        createNews,
        isCreating,
        updateNews,
        isUpdating,
        deleteNews,
        isDeleting,
        bulkUpdate,
        isBulkUpdating
    }
}